function initShippingNotices(context = document) {
  const outputContainer = context.querySelector('#variant-shipping-notice-container');
  const variantSelect = context.querySelector('select[name="id"], input[name="id"]');

  if (!outputContainer || !variantSelect) return;

  function updateShippingNotice(variantId) {
    const noticeEl = context.querySelector('#shipping-notice-' + variantId);

    if (noticeEl && noticeEl.innerHTML.trim() !== '') {
      outputContainer.innerHTML = noticeEl.innerHTML;
      outputContainer.style.display = 'block';
      outputContainer.style.color = noticeEl.style.color || ''; // inherit inline style
    } else {
      outputContainer.innerHTML = '';
      outputContainer.style.display = 'none';
      outputContainer.style.color = '';
    }
  }

  updateShippingNotice(variantSelect.value);

  variantSelect.addEventListener('change', function () {
    updateShippingNotice(this.value);
  });
}


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-form').forEach(formEl => {
    const form = formEl.querySelector('form[is="product-form"], form.shopify-product-form');
    if (form) initShippingNotices(formEl);
  });
});

